import {  Paper, makeStyles, TextField, Typography, TextareaAutosize, IconButton } from '@material-ui/core';
import React from 'react'

const Contact = ({title, dark, id}) => {
    const classes = useStyles();
    const [name, setName] = React.useState("")
    const [legend, setLegend] = React.useState("")
    const [legendEmail, setLegendEmail] = React.useState("")
    const [legendText, setLegendText] = React.useState("")
    const [error, setError] = React.useState("")
    const [email, setEmail] = React.useState("")
    const [errorEmail, setErrorEmail] = React.useState("")
    const [text, setText] = React.useState("")
    const emailRegex = /(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)/;
  
    const handleSubmit = (e)=>{
        e.preventDefault();
        
    }
    return (
        <div className ={`${classes.section} ${classes.sectiondark}`}>
       <div className={classes.sectioncontent} id={ id}>
                <Typography variant= "h3" className={classes.titlesection}>{title}</Typography>
                <Paper className={classes.root}>

                    <form className={classes.form} onSubmit={handleSubmit} autoComplete="on">
                    <TextField
                    className={classes.input}
                    onChange ={(e)=>{
                        setName(e.target.value);
                        if(name.length > 15){
                            setError(true);
                            setLegend("Your name is too long")
                        }else{
                            setError(false);
                            setLegend("");
                        }
                    }}
                    error={error}
                    label="Name"
                    helperText={legend}
                    variant="outlined"
                    required
                        
                    />
                     <TextField
                       className={classes.input}
                      onChange ={(e)=>{
                        setEmail(e.target.value);
                        if (!emailRegex.test(email)){
                            setErrorEmail(true);
                            setLegendEmail("Please enter a valid email!")
                        }else{
                            setErrorEmail(false);
                            setLegendEmail("");
                        }
                    }}
                    error={errorEmail}
                    label="Email"
                    helperText={legendEmail}
                    variant="outlined"
                    required
                      
                    />
                    <TextareaAutosize 
                    className={classes.textarea}
                    onChange ={(e)=>{
                        setEmail(e.target.value);
                        if (text.isEmpty){
                            setError(true);
                            setLegend("Please enter a valid message!")
                        }else{
                            setError(false);
                            setLegend("");
                        }
                    }}
                    aria-label="empty textarea" 
                    placeholder="Write the message"
                    error={error}
                    label="Message"
                    helperText={legendText}
                    variant="outlined"
                    required />
                   
                
                    </form>
                    <IconButton variant="contained"
                    className={classes.btn}>Send</IconButton>
                </Paper>
                

            </div>
    </div>
    )
}

const useStyles = makeStyles((theme) => ({
    section:{
        padding:'300px auto'
    },
    titlesection:{
        paddingTop: "2rem",
        [theme.breakpoints.down('sm')]:{
            padding: "0px 20px",
            fontSize:"2rem"
        }
        
    },
  
    sectioncontent:{
        maxWidth: "80vw",
        margin: "0 auto",
        paddingBottom:'400px',
        display:"flex",
        justifyContent:"space-between",
        [theme.breakpoints.down('sm')]:{
            display: "block",
            margin: "20px"
        }
    },
    root:{
        boxShadow:'none',
        width:"500px",
        "& button":{
            backgroundColor: "#353651",
            padding:"5px 20px",
            color:'white',
            padding:theme.spacing(1),
            margin:"0em 2em 1em 2em",
            borderRadius: "2px",
           [theme.breakpoints.down('sm')]:{
            margin:"0em 2em 1em 1.5em",
            
        }
        },
        "& button:hover":{
            backgroundColor: "#d888af",
            color:"white"
        },
         [theme.breakpoints.down('sm')]:{
            width:"90vw",
            height:"60vh"
        }
    },
    form:{
        display:"flex",
        flexDirection:"column", 
        width: "400px",
        marginTop:"50px",
        padding:"40px",
  [theme.breakpoints.down('sm')]:{
            width:"80vw",
            height:"43vh",
            padding: "20px"
        }
    },
    input:{
        margin: "10px",
        border: "#353651 ! important",
    },
    textarea:{
        minHeight:"200px",
        margin: "10px 10px 0px 10px",
        padding: "10px",
        [theme.breakpoints.down('sm')]:{
            minHeight:"100px"
        }
    },
     

}))

export default Contact
